import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { IceCreamCone, Menu, X, Phone } from "lucide-react";
import { SITE, NAV_LINKS } from "../data/site";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="sticky top-0 z-50 border-b border-blue-100 bg-white/90 backdrop-blur-md" data-testid="site-header">
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-6" aria-label="Main navigation">
        <Link to="/" className="flex items-center gap-2.5 focus:outline-none focus:ring-4 focus:ring-blue-300 rounded-full" data-testid="nav-logo">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-yellow-400 shadow-md shadow-yellow-400/40">
            <IceCreamCone className="h-6 w-6 text-slate-900" aria-hidden="true" />
          </span>
          <span className="leading-tight">
            <span className="block font-display text-lg font-semibold text-blue-600">Ms. Jeanette's</span>
            <span className="block text-[11px] font-extrabold uppercase tracking-widest text-slate-500">Shaved Ice Snowballs</span>
          </span>
        </Link>

        <div className="hidden items-center gap-1 xl:flex">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`nav-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `rounded-full px-3.5 py-2 text-sm font-bold transition-colors duration-200 focus:outline-none focus:ring-4 focus:ring-blue-300 ${
                  isActive ? "bg-blue-100 text-blue-700" : "text-slate-600 hover:bg-blue-50 hover:text-blue-600"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href={SITE.phoneHref}
            data-testid="nav-call-button"
            className="hidden items-center gap-2 rounded-full bg-red-500 px-5 py-2.5 text-sm font-extrabold text-white shadow-lg shadow-red-500/30 transition-transform duration-200 hover:-translate-y-0.5 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-red-300 sm:inline-flex"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            {SITE.phone}
          </a>
          <button
            type="button"
            onClick={() => setOpen(!open)}
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="mobile-menu-button"
            className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-blue-100 text-blue-700 transition-colors hover:bg-blue-200 focus:outline-none focus:ring-4 focus:ring-blue-300 xl:hidden"
          >
            {open ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-blue-100 bg-white px-4 pb-6 pt-3 xl:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `rounded-2xl px-4 py-3 text-base font-bold transition-colors focus:outline-none focus:ring-4 focus:ring-blue-300 ${
                    isActive ? "bg-blue-100 text-blue-700" : "text-slate-600 hover:bg-blue-50"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a
              href={SITE.phoneHref}
              data-testid="mobile-menu-call-button"
              className="mt-3 inline-flex items-center justify-center gap-2 rounded-full bg-red-500 px-5 py-3.5 text-base font-extrabold text-white shadow-lg shadow-red-500/30 focus:outline-none focus:ring-4 focus:ring-red-300"
            >
              <Phone className="h-5 w-5" aria-hidden="true" />
              Call Ms. Jeanette — {SITE.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
